import React from 'react';
import { connect } from 'react-redux';
import { FieldArray, reduxForm } from 'redux-form';

import { CategoriesPrices, FormActionButtons } from 'components';

import { CATEGORIES } from 'pages/create-activity/constants';

import validate from './validate';

import { useStyles } from './styles';

const initialValues = {
  categories: [
    {
      name: 'Adult',
      USD: '0',
      EUR: '0',
      NOK: '0'
    }
  ]
};

const PricesEqual = ({
  handleSubmit,
  pricesEqualForm,
  setSubmitButton,
  isUpdate
}) => {
  const classes = useStyles();

  const getAvailableCategoriesNames = () => {
    const categories = pricesEqualForm.values.categories.map(
      item => item.participant
    );
    return CATEGORIES.filter(x => !categories.includes(x));
  };

  return (
    <div>
      <form onSubmit={handleSubmit} className={(classes.form)}>
        <div className={(classes.fields )}>
          <FieldArray 
            name="categories"
            component={CategoriesPrices}
            availableCategories={getAvailableCategoriesNames()}
            tabName="price"
            tabNameAll="all prices"
          />
        </div>
        <FormActionButtons
          cancelPath="/accommodations-and-activities"
          actionLabel="Next"
          setSubmitButton={setSubmitButton}
          isUpdate={isUpdate}
        />
      </form>
    </div>
  );
};

const mapStateToProps = state => ({
  pricesEqualForm: state.form.pricesEqualForm
});

export default reduxForm({
  form: 'pricesEqualForm',
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: true,
  touchOnBlur: false,
  validate,
  initialValues
})(connect(mapStateToProps, null)(PricesEqual));
